import axios from 'axios'

const getLocalJson = axios.create({
  baseURL: '/static/json'
})

const getCloudStorage = axios.create({
  baseURL: `${process.env.VUE_APP_CLOUD_STORAGE_URL}/storage/v1/b/h365-landing-page/o`
})

// 添加请求拦截器
getCloudStorage.interceptors.request.use(
  (config) => {
    console.log('🚀 Axios Request Interceptor:', {
      method: config.method?.toUpperCase(),
      url: config.url,
      baseURL: config.baseURL,
      fullURL: `${config.baseURL}/${config.url}`,
      params: config.params,
      headers: config.headers,
      data: config.data
    })
    return config
  },
  (error) => {
    console.error('❌ Axios Request Error:', error)
    return Promise.reject(error)
  }
)

// 添加响应拦截器
getCloudStorage.interceptors.response.use(
  (response) => {
    console.log('✅ Axios Response Interceptor:', {
      status: response.status,
      statusText: response.statusText,
      url: response.config.url,
      data: response.data
    })
    return response
  },
  (error) => {
    console.error('❌ Axios Response Error:', {
      status: error.response?.status,
      statusText: error.response?.statusText,
      url: error.config?.url,
      message: error.message,
      response: error.response?.data
    })
    return Promise.reject(error)
  }
)

export {
  getLocalJson,
  getCloudStorage
}